// extracted by mini-css-extract-plugin
module.exports = {"container":"checkBox_container__PYPzF","checkmark":"checkBox_checkmark__3_ncS","indeterminate":"checkBox_indeterminate__ZXPTb","label":"checkBox_label__16rrb"};